document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const open = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!open));
      mobileMenu.hidden = open;
    });
  }

  // Keep Shopify's required variant ID in sync with the product option selectors.
  // This prevents "Parameter Missing or Invalid: items" errors when adding a product.
  document.querySelectorAll('.product-form').forEach((form) => {
    const variantInput = form.querySelector('[data-variant-id]');
    const optionSelects = Array.from(form.querySelectorAll('[data-option-position]'));
    const addButton = form.querySelector('[data-add-to-cart]');
    const errorEl = form.querySelector('[data-product-form-error]');
    const variantData = document.querySelector('[data-product-variants]');

    if (!variantInput || !variantData) return;

    let variants;
    try {
      variants = JSON.parse(variantData.textContent);
    } catch (error) {
      return;
    }

    const setError = (message) => {
      if (!errorEl) return;
      errorEl.textContent = message || '';
      errorEl.hidden = !message;
    };

    const updateVariant = () => {
      const selectedOptions = optionSelects.map((select) => select.value);
      const variant = variants.find((item) =>
        item.options.every((value, index) => value === selectedOptions[index])
      );

      setError('');

      if (!variant) {
        variantInput.value = '';
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = 'UNAVAILABLE';
        }
        return;
      }

      variantInput.value = String(variant.id);

      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      }

      const priceEl = form.closest('.product-info')?.querySelector('[data-product-price]');
      if (priceEl && variant.price) {
        const moneyFormat = priceEl.dataset.moneyFormat;
        if (moneyFormat) {
          priceEl.textContent = moneyFormat.replace('{{amount}}', (variant.price / 100).toFixed(2));
        }
      }
    };

    optionSelects.forEach((select) => {
      select.addEventListener('change', updateVariant);
    });

    form.addEventListener('submit', async (event) => {
      // Let Shopify handle the normal form submission. The important part is
      // that the form always contains a valid name="id" variant value.
      if (!variantInput.value) {
        event.preventDefault();
        setError('Please select an available product option.');
      }
    });

    updateVariant();
  });
});
